/**
 * @fileoverview Unsubscribe page module initialization.
 * Initializes validation and interaction handlers for the marketing campaign unsubscribe page.
 */
import validationInit from './handlers/validation';
import interactionInit from './handlers/interaction';

require('features/segment');

// initialization of the unsubscribe page
validationInit();
interactionInit();
